import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import axios from "axios";

import "./scss/app.scss";

import App from "./App";

import store from "./redux/store/store";


class Cart 
{
    LOCAL_STORAGE_KEY = "cart"

    constructor()
    {
        const cart = localStorage.getItem(this.LOCAL_STORAGE_KEY);

        if (cart) {
            this.stored = JSON.parse(cart);
        } else {
            this.stored = {}
        }

    }

    saveToLocalStoge() {
        const jsonStored = JSON.stringify(this.stored)
        localStorage.setItem(this.LOCAL_STORAGE_KEY, jsonStored)
    }
    
    add(item, addedQuantity = 1)
    {
        let itemCode = item.code;
        if (Object.keys(this.stored).includes(itemCode))
            this.stored[`${itemCode}`].quantity += addedQuantity;
        else this.stored[`${itemCode}`] = {...item, quantity: addedQuantity};

        this.saveToLocalStoge()
    }
    set(item, quantity)
    {
        let itemCode = item.code;
        quantity? (this.stored[`${itemCode}`].quantity = quantity) : (delete this.stored[`${itemCode}`]);
        this.saveToLocalStoge()
    }
    
    rem(item, removedQuantity = 1)
    {
        let itemCode = item.code, itemInCart = this.stored[`${itemCode}`];
        if (itemInCart.quantity - removedQuantity)
            itemInCart.quantity -= removedQuantity;
        else delete this.stored[`${itemCode}`];
        this.saveToLocalStoge()
    }
    
    remAll(item)
    {
        delete this.stored[`${item.code}`];
        this.saveToLocalStoge()
    }
    
    clear()
    {
        this.stored = {};
        this.saveToLocalStoge()
    }
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<Provider store={store}>
		<App cart = { new Cart() } />
	</Provider>
);
